'use strict';

function yToMinutes(yPx, rowHeight, calendarStartHour) {
  return calendarStartHour * 60 + (yPx / rowHeight) * 60;
}

function snapToGrid(minutes, snapMinutes) {
  return Math.round(minutes / snapMinutes) * snapMinutes;
}

function clampStart(minutes, startHour, endHour, durationMinutes) {
  const min = startHour * 60;
  const max = endHour * 60 - durationMinutes;
  return Math.max(min, Math.min(max, minutes));
}

function findFreeSlotSnap(proposedStartMin, freeSlots, durationMinutes, thresholdMin) {
  const fits = (s) => s.endMin - s.startMin >= durationMinutes;

  for (const slot of freeSlots) {
    if (fits(slot) && proposedStartMin >= slot.startMin && proposedStartMin < slot.endMin) {
      return slot.startMin;
    }
  }

  let best = null;
  let bestDist = Infinity;
  for (const slot of freeSlots) {
    if (!fits(slot)) continue;
    const d = Math.abs(slot.startMin - proposedStartMin);
    if (d <= thresholdMin && d < bestDist) {
      best = slot.startMin;
      bestDist = d;
    }
  }
  return best;
}

function computeDrop(opts) {
  const {
    mode, proposedStartMin, freeSlots, durationMinutes,
    snapMinutes, thresholdMin, startHour, endHour,
  } = opts;

  const slotStart = findFreeSlotSnap(proposedStartMin, freeSlots, durationMinutes, thresholdMin);

  if (mode === 'student') {
    if (slotStart == null) {
      return { startMin: proposedStartMin, snappedToSlot: false, valid: false };
    }
    return { startMin: slotStart, snappedToSlot: true, valid: true };
  }

  // manager: magnetic, else grid
  let startMin = slotStart != null ? slotStart : snapToGrid(proposedStartMin, snapMinutes);
  startMin = clampStart(startMin, startHour, endHour, durationMinutes);
  return { startMin, snappedToSlot: slotStart != null, valid: true };
}

module.exports = { yToMinutes, snapToGrid, clampStart, findFreeSlotSnap, computeDrop };
